"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3.57275 24.3666L4.26029 23.4082C4.61446 22.929 12.7811 11.7208 24.6978 11.3875H25.2186C26.1039 11.387 26.9881 11.4495 27.8644 11.5749L26.2811 14.554C25.7824 14.509 25.2815 14.4951 24.7811 14.5125C16.3228 14.7416 9.7186 21.7 7.55193 24.2833C10.1645 27.4786 13.3335 30.1748 16.9061 32.2416L15.4478 34.9708C11.1475 32.5007 7.36895 29.2175 4.32279 25.3041L3.57275 24.3666Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.3436 24.6791C17.3444 22.6159 18.1543 20.6352 19.5995 19.1627C21.0448 17.6902 23.0099 16.8433 25.0728 16.8041L23.177 20.3875C22.3661 20.7738 21.6813 21.3819 21.202 22.1415C20.7226 22.901 20.4684 23.7809 20.4686 24.6791C20.4678 24.9167 20.4887 25.1537 20.5311 25.3874L18.6353 28.9708C17.7863 27.7011 17.3365 26.2065 17.3436 24.6791Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.9478 39.3875L20.2394 36.9499C22.2175 37.5012 24.2723 37.7264 26.3228 37.6165C37.9686 36.9499 45.427 25.6374 45.7395 25.1583L46.3644 24.2207L45.6561 23.3249C42.3518 18.871 37.9821 15.3178 32.9478 12.9915L34.4269 10.2208L31.6561 8.74158L31.6353 8.78328L31.677 8.80414L29.9895 11.9916L28.4686 14.8457L25.7602 19.9708L21.6144 27.7833L18.7811 33.1375L17.3228 35.9082L16.2395 37.9499L18.9478 39.3875ZM28.552 21.3041C29.2234 21.9648 29.6829 22.8105 29.872 23.7333C30.061 24.6562 29.9711 25.6144 29.6135 26.4859C29.256 27.3574 28.6471 28.1027 27.8644 28.6268C27.0817 29.151 26.1606 29.4303 25.2186 29.4291C24.9035 29.4253 24.5894 29.3904 24.2811 29.3249L28.552 21.3041ZM22.7811 32.1582C23.5652 32.4278 24.3895 32.5617 25.2186 32.5541C26.8594 32.5555 28.4595 32.0439 29.7952 31.091C31.1309 30.1381 32.1353 28.7916 32.668 27.2397C33.2006 25.6878 33.2347 24.0081 32.7657 22.4358C32.2966 20.8635 31.3478 19.4771 30.052 18.4707L31.4894 15.7624C35.7971 17.6905 39.5667 20.6447 42.4686 24.3666C40.5103 26.9291 34.4061 34.0332 26.1353 34.4915C24.6597 34.5741 23.1797 34.4478 21.7394 34.1166L22.7811 32.1582Z",
    fill: fill
  }));
};

exports["default"] = _default;